// extracted by mini-css-extract-plugin
export default {"root":"ruleModal_root__1ytD5","roots":"ruleModal_roots__vQ9pN","item":"ruleModal_item__1rngv","text":"ruleModal_text__+hvAs"};